import { createFileRoute, redirect } from "@tanstack/react-router";

// Catch-all redirect: /blogs/<blog>/<article> → /field-notes/<blog>/<article>
export const Route = createFileRoute("/blogs/$blog/$article")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/field-notes/$blog/$article",
      params: { blog: params.blog, article: params.article },
      statusCode: 301,
    });
  },
});
